require('../../modules/es6.object.define-properties');
var $Object = require('../../modules/_core').Object;
module.exports = function defineProperties(T, D) {
  return $Object.defineProperties(T, D);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/object/define-properties.js
 ** module id = 795
 ** module chunks = 0
 **/